import React from 'react';

const AsideInfo = () => {
    return (
        <div className="aside_info_wrapper">
            <button className="aside_close"><i className="bi bi-x-lg"></i></button>
            <div className="aside_logo">
                <a href="/" className="light_logo"><img src="images/logo-light-lg.svg" alt="logo" /></a>
                <a href="/" className="dark_logo"><img src="images/logo-dark-lg.svg" alt="logo" /></a>
            </div >
            <div className="aside_info_inner">
                <p>Florida Luxury Landscape is a full-service design firm providing luxurious 3D landscaping designs & project management.</p>
                
                <div className="aside_info_inner_box">
                    <h5>Contact Info</h5>
                    <p>1-844-262-4828</p>
                    <p>Florida, USA</p>
                    <p>hello@formulatelabs.com</p>
                </div>
                <div className="social_sites">
                    <ul className="d-flex align-items-center justify-content-center">
                        <li><a><i className="bi bi-facebook"></i></a></li>
                        <li><a><i className="bi bi-twitter"></i></a></li>
                        <li><a><i className="bi bi-instagram"></i></a></li>
                        <li><a><i className="bi bi-youtube"></i></a></li>
                    </ul>
                </div>
            </div>
        </div >

    );
};

export default AsideInfo;
